// extracted by mini-css-extract-plugin
module.exports = {"root":"FilesFlatList_root__p2HM9","head":"FilesFlatList_head__o_yA5"};